import { UserAccount } from '@/coreDomainsModule/entities/users';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IUserRepository } from '@/coreInfrastructureModule/interfaces/IUserRepository';
import { UserAdapter } from '../adapter/userAdapter';

/**
 * 組織内のユーザー一覧を取得するUseCase
 */
export class GetAllUsersUseCase {
  private repository: IUserRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IUserRepository) {
    this.repository = repository;
  }

  /**
   * 組織内のユーザー一覧を取得する
   * @param keyword - ユーザー名検索キーワード
   */
  async execute(keyword?: string): Promise<INetworkResult<UserAccount[], IError>> {
    try {
      const result = await this.repository.get(keyword);
      switch (result.status.type) {
        case 'success':
          const data = UserAdapter.adapt(result.status.data.data);
          return {
            status: {
              type: 'success',
              data: data,
            },
          };
        case 'error':
          return {
            status: {
              type: 'error',
              error: result.status.error,
            },
          };
        default:
          throw new Error('Unexpected error');
      }
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: {
            statusCode: -1,
            code: 'unknown',
            message: 'Unexpected error has occured',
          },
        },
      };
    }
  }
}
